export default __webpack_public_path__ + "static/media/schultenumbers_locked.a9b257fa.svg";